// frontend/src/services/api.js

import axios from 'axios';
import { API_BASE_URL } from '../config.js';

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Se for 401 e não for requisição de autenticação e ainda não tentamos renovar
    if (
      error.response &&
      error.response.status === 401 &&
      originalRequest &&
      !originalRequest._retry &&
      !originalRequest.url.includes('/token/')
    ) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refreshToken');

      if (refreshToken) {
        try {
          const res = await axios.post(`${API_BASE_URL}/token/refresh/`, {
            refresh: refreshToken,
          });

          if (res.status === 200) {
            const newAccess = res.data.access;
            localStorage.setItem('accessToken', newAccess);
            if (res.data.refresh) {
              localStorage.setItem('refreshToken', res.data.refresh);
            }
            api.defaults.headers.common['Authorization'] = `Bearer ${newAccess}`;
            originalRequest.headers['Authorization'] = `Bearer ${newAccess}`;
            return api(originalRequest);
          }
        } catch (refreshError) {
          console.error('Sessão expirada. Redirecionando para login...', refreshError);
        }
      }

      // Se falhou o refresh ou não tem refreshToken, limpa e redireciona
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export const getOperatorDocuments = () => {
  return api.get('/documentos/');
};

export const getSingleDocument = (documentId) => {
  return api.get(`/documentos/${documentId}/`);
};

export const deleteDocument = (documentId) => {
  return api.delete(`/documentos/${documentId}/`);
};

export default api;